import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import Articulo70 from './components/Articulo70/Articulo70';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Paaas from "./components/Paaas/Paaas";
import Resoluciones from "./components/Resoluciones/Resoluciones";
import Contratos from "./components/Contratos/Contratos";
import Boletines from "./components/Boletines/Boletines";
import Sail from "./components/Sail/Sail";
import Formulario from "./components/Formulario/Formulario";
import Uiimh from "./components/Uiimh/Uiimh";
import Programas from "./components/Programas/Programas";
import Ligas_Interes from "./components/Ligas_Interes/Ligas_Interes";
import Acciones from "./components/Acciones/Acciones";
import Reglas from "./components/Reglas/Reglas";
import Avisos_Privacidad from "./components/Avisos_Privacidad/Avisos_Privacidad";
import Mision from "./components/Uiimh/Mision";
import Objetivo from "./components/Uiimh/Objetivo";
import Videos from "./components/Uiimh/Videos";
import Error404 from "./components/Error404/Error404";
//import Procuraduria from "./components/Procuraduria/Procuraduria";
//import Sneh from "./components/Sneh/Sneh";
//import Especiales from "./components/Especiales/Especiales";
//import Junta_local from "./components/Junta_local/Junta_local";
//import Dga from "./components/Dga/Dga";
//import Planeacion from "./components/Planeacion/Planeacion";
//import Intranet from "./components/Intranet/Intranet";
//import Convocatorias from "./components/Convocatorias/Convocatorias";

function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Articulo70" element={ <Articulo70/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="/Paaas" element={ <Paaas/> } />
          <Route exact path="/Resoluciones" element={ <Resoluciones/> } />
          <Route exact path="/Contratos" element={ <Contratos/> } />
          <Route exact path="/Boletines" element={ <Boletines/> } />
          <Route exact path="/Sail" element={ <Sail/> } />
          <Route exact path="/Ligas_Interes" element={ <Ligas_Interes/> } />
          <Route exact path="/Reglas" element={ <Reglas/> } />
          <Route exact path="/Avisos_Privacidad" element={ <Avisos_Privacidad/> } />
          <Route exact path="/Formulario" element={ <Formulario/> } />
          <Route exact path="/Uiimh" element={ <Uiimh/> } />
          <Route exact path="/Mision" element={ <Mision/> } />
          <Route exact path="/Objetivo" element={ <Objetivo/> } />
          <Route exact path="/Videos" element={ <Videos/> } />
          <Route exact path="/Acciones" element={ <Acciones/> } />
          <Route exact path="/Programas" element={ <Programas/> } />
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;

